var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('zoezi-autocomplete',{attrs:{"label":_vm.label,"items":_vm.routes,"value":_vm.value,"clearable":_vm.clearable,"itemMissing":function (value) { return ((this$1.$translate('Selected page not available')) + ": " + value); }},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }